import { Box, Typography } from '@mui/material';

export const NoPatientFoundPlaceholder = () => {
  return (
    <>
      <Typography variant='body2' sx={{ color: 'text.secondary' }}>
        1. Make sure the patient is in Salesforce as an{' '}
        <Box component='span' sx={{ fontWeight: 600 }}>
          Account
        </Box>{' '}
        (not as a Prospect).
      </Typography>

      <Typography variant='body2' sx={{ color: 'text.secondary' }}>
        2. Check the{' '}
        <Box component='span' sx={{ fontWeight: 600 }}>
          patient status in Salesforce Care Connect
        </Box>{' '}
        and ensure it is one of the following:
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box
          sx={{
            height: 4,
            width: 4,
            borderRadius: '50%',
            bgcolor: theme => theme.palette.grey[500],
            ml: 3,
          }}
        />
        <Typography color='textSecondary' variant='body2'>
          Active PCP
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box
          sx={{
            height: 4,
            width: 4,
            borderRadius: '50%',
            bgcolor: theme => theme.palette.grey[500],
            ml: 3,
          }}
        />
        <Typography color='textSecondary' variant='body2'>
          Active PRN
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box
          sx={{
            height: 4,
            width: 4,
            borderRadius: '50%',
            bgcolor: theme => theme.palette.grey[500],
            ml: 3,
          }}
        />
        <Typography color='textSecondary' variant='body2'>
          Active PCP w/ Phys. Rep / 602
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box
          sx={{
            height: 4,
            width: 4,
            borderRadius: '50%',
            bgcolor: theme => theme.palette.grey[500],
            ml: 3,
          }}
        />
        <Typography color='textSecondary' variant='body2'>
          Phys. Rep. / 602 Only
        </Typography>
      </Box>

      <Typography variant='body2' sx={{ color: 'text.secondary' }}>
        3. After saving the correct status,{' '}
        <Box component='span' sx={{ fontWeight: 600 }}>
          wait up to one hour
        </Box>{' '}
        for the patient data to synchronize between Salesforce and Bridge.
      </Typography>
    </>
  );
};
